import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { InstantSearch, useConfigure, useHits } from 'react-instantsearch'

import SearchBar, { SearchBarProps } from '../Layouts/Header/Search/Search'
import { typesenseInstantSearchAdapter } from '../../utils/typesense/config'
import { getCountryAndLocaleStrings } from '../../utils/locales'

interface TopSuppliersProps {
  setSupplierList: Dispatch<SetStateAction<{ label: string, value: string, id: string }[]>>
}

const TopSuppliers: FC<TopSuppliersProps> = ({ setSupplierList }) => {
  const { results } = useHits()
  const { locale } = useRouter()
  const { country } = getCountryAndLocaleStrings(locale)

  // Filter by country availability
  useConfigure({
    facetsRefinements: {
      'country-availability': [country.toUpperCase()],
    },
  })

  useEffect(() => {
    const supplierData = results?.hits
      .map(({ name, id }) => ({ label: name, id, value: name }))
    if (supplierData?.length) {
      setSupplierList(supplierData)
    }
  }, [results])
  return null
}
/** Inject list of suppliers from separate search instance
 * to prevent filtering from applying to suppliers
 * @param props
 * @constructor
 */
const SearchWrapper: FC<SearchBarProps> = (props) => {
  const [supplierList, setSupplierList] = useState<{
    label: string
    value: string
    id: string
  }[]>([])

  const header = { label: 'Popular Brands', value: '', id: '' }
  const listWithHeader = supplierList.length
    ? [header, ...supplierList]
    : []

  return (
    <>
      <InstantSearch
        indexName="suggestions"
        searchClient={typesenseInstantSearchAdapter.searchClient}
      >
        <SearchBar
          brandList={listWithHeader}
          {...props}
        />
      </InstantSearch>
      <InstantSearch
        indexName="suppliers"
        searchClient={typesenseInstantSearchAdapter.searchClient}
      >
        <TopSuppliers setSupplierList={setSupplierList} />
      </InstantSearch>
    </>
  )
}

export default SearchWrapper
